import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as hodublastServices from "../../../services/hodublast/index";
import { toast } from "react-toastify";

export const fetchHodublastJobs = createAsyncThunk(
    "hodublast/fetchJobs",
    async (payload, thunkAPI) => {
        try {
            const result = await hodublastServices.getHodublastJobs(payload);
            console.log("Result in fetchHodublastJobs:", result);

            if (result?.success) {
                return result?.data || [];
            } else {
                return thunkAPI.rejectWithValue(result?.message || "Something went wrong!");
            }
        } catch (err) {
            console.log("Error in fetchHodublastJobs:", err);
            return thunkAPI.rejectWithValue(err?.message || "Internal Server Error");
        }
    }
);

export const addHodublastJobs = createAsyncThunk(
    "hodublast/addJobs",
    async (payload, thunkAPI) => {
        try {
            const result = await hodublastServices.addHodublastJobs(payload);
            console.log("Result in addHodublastJobs:", result);

            if (result?.success) {
                return result?.message || "Jobs added successfully!";
            } else {
                toast.error(result?.message || "Something went wrong!");
                return thunkAPI.rejectWithValue(result?.message || "Something went wrong!");
            }
        } catch (err) {
            console.log("Error in addHodublastJobs:", err);
            toast.error(err?.message || "Internal Server Error!");
            return thunkAPI.rejectWithValue(err?.message || "Internal Server Error!");
        }
    }
);

export const deleteHodublastJob = createAsyncThunk(
    'hodublast/deleteJob',
    async (payload, thunkAPI) => {
        try {
            const result = await hodublastServices.deleteHodublastJob(payload);
            console.log("Result in deleteHodublastJob:", result);

            if (result?.success) {
                toast.success(result?.message || "Job deleted successfully!");
                return result;
            } else {
                toast.error(result?.message || "Something went wrong!");
                return thunkAPI.rejectWithValue(result);
            }
        } catch (err) {
            console.error("Error in deleteHodublastJob:", err);
            toast.error(err?.message || "Internal Server Error!");
            return thunkAPI.rejectWithValue({
                success: false,
                message: err?.message || "Internal Server Error!",
            });
        }
    }
);

export const fetchHodublastReportData = createAsyncThunk(
    "hodublast/fetchReportData",
    async (payload, thunkAPI) => {
        try {
            const result = await hodublastServices.getHodublastReportData(payload);
            console.log("Result in fetchHodublastReportData:", result);
            if (result?.success) {
                return result?.data || {};
            } else {
                return thunkAPI.rejectWithValue(result?.message || "Something went wrong!");
            }
        } catch (err) {
            console.log("Error in fetchHodublastReportData:", err);
            return thunkAPI.rejectWithValue(err?.message || "Internal Server Error");
        }
    }
);

export const addAdminTestContacts = createAsyncThunk(
    'hodublast/addAdminTestContacts',
    async (payload, thunkAPI) => {
        try {
            const result = await hodublastServices.addAdminTestContacts(payload);
            console.log("Result in addAdminTestContacts:", result);
            if (result?.success) {
                return result?.data || {};
            } else {
                return thunkAPI.rejectWithValue(result?.message || "Something went wrong!");
            }
        } catch (err) {
            console.log("Error in addAdminTestContacts:", err);
            return thunkAPI.rejectWithValue(err?.message || "Internal Server Error");
        }
    }
);

export const getAdminTestContacts = createAsyncThunk(
    'hodublast/getAdminTestContacts',
    async (payload, thunkAPI) => {
        try {
            const result = await hodublastServices.getAdminTestContacts(payload);
            console.log("Result in getAdminTestContacts:", result);
            if (result?.success) {
                return result?.data || {};
            } else {
                return thunkAPI.rejectWithValue(result?.message || "Something went wrong!");
            }
        } catch (err) {
            console.log("Error in getAdminTestContacts:", err);
            return thunkAPI.rejectWithValue(err?.message || "Internal Server Error");
        }
    }
);

export const downloadHodublastReportCSV = createAsyncThunk(
    "hodublast/downloadReportCSV",
    async (payload, thunkAPI) => {
        try {
            const result = await hodublastServices.exportHodublastDefaultersExportCSVFile(payload);
            console.log("Result in downloadHodublastReportCSV:", result);
            if (result?.success) {
                return result?.message || "CSV download initiated successfully!";
            } else {
                toast.error(result?.message || "Something went wrong!");
                return thunkAPI.rejectWithValue(result?.message || "Something went wrong!");
            }
        } catch (err) {
            console.log("Error in downloadHodublastReportCSV:", err);
            return thunkAPI.rejectWithValue(err?.message || "Internal Server Error");
        }
    }
);

export const deleteAdminTestContact = createAsyncThunk(
    "hodublast/deleteAdminTestContact",
    async (payload, thunkAPI) => {
        try {
            const res = await hodublastServices.deleteAdminTestContact(payload);
            if (res?.success) {
                toast.success(res?.message || "contact successfully removed");
                return res.message || "Contact Successfully deleted.";
            } else {
                toast.error(res?.message || "Something went wrong!");
                return thunkAPI.rejectWithValue(res?.message || "Something went wrong!");
            }
        } catch (err) {
            console.log("Error in deleteAdminTestContact:", err);
            return thunkAPI.rejectWithValue(err?.message || "Internal Server Error");
        }
    }
);

export const fetchAllHodublastJobs = createAsyncThunk(
    'hodublast/fetchAllHodublastJobs',
    async (payload, thunkAPI) => {
        try {

            const response = await hodublastServices.fetchAllHodublastJobs(payload);
            if (response?.success) {
                return response?.data || [];
            } else {
                return thunkAPI.rejectWithValue(response?.message || "Internal Server Error");
            }

        } catch (err) {
            console.log("Error in fetchAllHodublastJobs : ", err);
            return thunkAPI.rejectWithValue(err?.message || "Internal Server Error");
        }
    }
)

const initialState = {
    hodublastJobs: {
        data: [],
        loading: false,
        error: null,
    },
    addJobStatus: {
        loading: false,
        successMessage: null,
        errorMessage: null,
    },
    hodublastUploadReport: {
        data: [],
        totalCount: 0,
        totalPages: 0,
        pagination: {},
        filters: {},
        loading: false,
        error: null,
    },
    adminTestContacts: {
        data: [],
        loading: false,
        error: null,
    },
    allHodublastJobs: {
        data: [],
        loading: false,
        error: null,
    }
};

const hodublastSlice = createSlice({
    name: "hodublast",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Fetch Jobs
        builder
            .addCase(fetchHodublastJobs.pending, (state) => {
                state.hodublastJobs.loading = true;
                state.hodublastJobs.error = null;
            })
            .addCase(fetchHodublastJobs.fulfilled, (state, action) => {
                state.hodublastJobs.loading = false;
                state.hodublastJobs.data = action.payload;
                state.hodublastJobs.error = null;
            })
            .addCase(fetchHodublastJobs.rejected, (state, action) => {
                state.hodublastJobs.loading = false;
                state.hodublastJobs.data = [];
                state.hodublastJobs.error = action.payload || "Something went wrong!";
            });

        // Add Jobs
        builder
            .addCase(addHodublastJobs.pending, (state) => {
                state.addJobStatus.loading = true;
                state.addJobStatus.successMessage = null;
                state.addJobStatus.errorMessage = null;
            })
            .addCase(addHodublastJobs.fulfilled, (state, action) => {
                state.addJobStatus.loading = false;
                state.addJobStatus.successMessage = action.payload || "Jobs added successfully!";
                state.addJobStatus.errorMessage = null;
            })
            .addCase(addHodublastJobs.rejected, (state, action) => {
                state.addJobStatus.loading = false;
                state.addJobStatus.successMessage = null;
                state.addJobStatus.errorMessage = action.payload || "Failed to add jobs!";
            });

        // hodublast upload report data
        builder
            .addCase(fetchHodublastReportData.pending, (state) => {
                state.hodublastUploadReport.loading = true;
                state.hodublastUploadReport.error = null;
            })
            .addCase(fetchHodublastReportData.fulfilled, (state, action) => {
                state.hodublastUploadReport.loading = false;
                state.hodublastUploadReport.data = action.payload.records || [];
                state.hodublastUploadReport.totalCount = action.payload.totalCount || 0;
                state.hodublastUploadReport.totalPages = action.payload.pagination?.totalPages || 0;
                state.hodublastUploadReport.pagination = action.payload.pagination || {};
                state.hodublastUploadReport.filters = action.payload.filters || {};
                state.hodublastUploadReport.error = null;
            })
            .addCase(fetchHodublastReportData.rejected, (state, action) => {
                state.hodublastUploadReport.loading = false;
                state.hodublastUploadReport.data = [];
                state.hodublastUploadReport.totalCount = 0;
                state.hodublastUploadReport.totalPages = 0;
                state.hodublastUploadReport.pagination = {};
                state.hodublastUploadReport.filters = {};
                state.hodublastUploadReport.error = action.payload || "Something went wrong!";
            });

        // getAdminTestContacts
        builder
            .addCase(getAdminTestContacts.pending, (state) => {
                state.adminTestContacts.data = [];
                state.adminTestContacts.loading = true;
                state.adminTestContacts.error = null;
            })
            .addCase(getAdminTestContacts.fulfilled, (state, action) => {
                state.adminTestContacts.data = action.payload;
                state.adminTestContacts.loading = false;
                state.adminTestContacts.error = null;
            })
            .addCase(getAdminTestContacts.rejected, (state, action) => {
                state.adminTestContacts.data = [];
                state.adminTestContacts.loading = false;
                state.adminTestContacts.error = action.payload || "Something went wrong!";
            });

        //fetchAllHodublastJobs
        builder
            .addCase(fetchAllHodublastJobs.pending, (state) => {
                state.allHodublastJobs.data = [];
                state.allHodublastJobs.loading = true;
                state.allHodublastJobs.error = null;
            })
            .addCase(fetchAllHodublastJobs.fulfilled, (state, action) => {
                state.allHodublastJobs.data = action.payload;
                state.allHodublastJobs.loading = false;
                state.allHodublastJobs.error = null;
            })
            .addCase(fetchAllHodublastJobs.rejected, (state, action) => {
                state.allHodublastJobs.data = [];
                state.allHodublastJobs.loading = false;
                state.allHodublastJobs.error = action.payload || "Something went wrong!";
            });
    },
});

export const hodublastReducer = hodublastSlice.reducer;
